import { createSelector } from 'reselect'
import { startsWith, cloneDeep } from 'lodash';
import { ledgermap } from './model'
import { textFilter, numberFilter } from '../../../utilities/listUtils'

export const getIsFetchingLedgermap = (state, props) => state.ledgermap.params.isFetching;
export const getIsLedgermapFetched = (state, props) => state.ledgermap.params.ledgermapFetched;
export const getLedgermapList = (state, prop) => state.ledgermap.byId
export const getIsSearching = (state, props) => state.ledgermap.params.isSearching;
export const getIsSearchFetched = (state, props) => state.ledgermap.params.searchFetched;
export const getSearchResults = (state, prop) => state.ledgermap.searchResults
export const filters = (state, prop) => state.ledgermap.filterResults;
export const getDeleteStatus = (state, prop) => state.ledgermap.deleteStatus
export const getDelFetched = (state, prop) => state.ledgermap.params.isDelFetched
export const getNotification = (state, id) => state.ledgermap.notifications[id]

export const getLedgermap = (state, props) => {
    if (props.match.path === '/ledgermap/create') {
        return ledgermap()
    }
    if (props.match.path === '/ledgermap/edit/:id') {
        let id = props.match.params.id
        let obj = cloneDeep(state.ledgermap.byId[id]);
        obj.cid = parseInt(obj.cid, 10)
        obj.segid = parseInt(obj.segid, 10)
        return obj
    }
    if (props.match.path === '/ledgermap/clone/:id') {
        let id = props.match.params.id
        let obj = cloneDeep(state.ledgermap.byId[id]);
        obj.cid = parseInt(obj.cid, 10)
        obj.segid = parseInt(obj.segid, 10)
        return obj
    }
}

export const getLedgermapParams = (state, props) => {
    const params = {}

    if (startsWith(state.router.location.pathname, '/ledgermap/create')) {
        params.title = state.ledgermap.params.createTitle
        params.submitButtonText = state.ledgermap.params.createSubmitButtonText
    };

    if (startsWith(state.router.location.pathname, '/ledgermap/edit/')) {
        params.title = state.ledgermap.params.editTitle
        params.submitButtonText = state.ledgermap.params.editSubmitButtonText
    };

    if (startsWith(state.router.location.pathname, '/ledgermap/clone/')) {
        params.title = state.ledgermap.params.cloneTitle
        params.submitButtonText = state.ledgermap.params.cloneSubmitButtonText
    };

    return params
}

export const selectLedgermap = createSelector(
    getLedgermapList,
    ledgermap => {
        const keys = Object.keys(ledgermap)
        const obj = keys.map((key) => { return { key: key, value: key, text: ledgermap[key].name } })
        return obj
    })


export const selectLedgermapSearched = createSelector(
    getSearchResults,
    ledgermap => {
        const keys = Object.keys(ledgermap)
        const obj = keys.map((key) => { return { key: key, value: key, text: ledgermap[key].name } })
        return obj
    })


export const getFilteredLedgermap = createSelector(
    getLedgermapList,
    (ledgermap) => {
        let filteredLedgermap = Object.keys(ledgermap).map(function (key) {
            return ledgermap[key];
        })
        return filteredLedgermap
    })

